import React from 'react'
import { connect } from 'react-redux'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import { TYPE_SELECT, TYPE_CONSTANT_VALUE } from 'helpers/jobs'
import messages from './translate'

function JobWorkflowInputForm(props) {
  const {
    onSubmit,
    formData: { translations, type },
    intl: { formatMessage },
  } = props

  return (
    <Paper className="licensee-paper">
      <Grid container spacing={1}>
        <Grid item container xs={12} sm={12}>
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine }) => (
              <form
                onSubmit={handleSubmit}
                className="form-basic licensee-form">
                {translations.map(
                  ({
                    title,
                    locale,
                    options,
                    constant_value,
                    unit,
                    images,
                  }) => (
                    <Grid key={`${title}_${locale}`}>
                      <h6>{locale.toUpperCase()}</h6>
                      <Field
                        name={`${locale}[title]`}
                        type="text"
                        label={`${locale} ${formatMessage(messages.title)}`}
                        component={Input}
                        className="form-control"
                        defaultValue={title}
                        disabled={submitting}
                        required={locale === 'en'}
                        validate={
                          locale === 'en'
                            ? getValidator(VALIDATOR_IS_EMPTY)
                            : null
                        }
                      />
                      {options && type === TYPE_SELECT && (
                        <Grid>
                          <h6>{formatMessage(messages.options)}</h6>
                          {Object.keys(options).map(item => (
                            <Field
                              name={`${locale}[options[${item}]]`}
                              type="text"
                              key={`${locale}${item}`}
                              label={`${locale} ${item}`}
                              component={Input}
                              className="form-control"
                              defaultValue={options[item]}
                              disabled={submitting}
                              required={locale === 'en'}
                              validate={
                                locale === 'en'
                                  ? getValidator(VALIDATOR_IS_EMPTY)
                                  : null
                              }
                            />
                          ))}
                        </Grid>
                      )}
                      {type === TYPE_SELECT && images && images.length && (
                        <Grid>
                          <h6>{formatMessage(messages.images)}</h6>
                          {Object.values(images).map((item, idx) => (
                            <>
                              <Field
                                name={`${locale}.images[${idx}].title`}
                                type="text"
                                key={`${locale} title`}
                                label={`${locale} title`}
                                component={Input}
                                className="form-control"
                                defaultValue={item.title}
                                disabled={submitting}
                              />
                              <Field
                                name={`${locale}.images[${idx}].description`}
                                type="text"
                                key={`${locale} description`}
                                label={`${locale} description`}
                                component={Input}
                                className="form-control"
                                defaultValue={item.description}
                                disabled={submitting}
                              />
                            </>
                          ))}
                        </Grid>
                      )}
                      {constant_value && type === TYPE_CONSTANT_VALUE && (
                        <Field
                          name={`${locale}[constant_value]`}
                          type="text"
                          label={`${locale} ${formatMessage(
                            messages.constantValue,
                          )}`}
                          component={Input}
                          className="form-control"
                          defaultValue={constant_value}
                          disabled={submitting}
                          required={locale === 'en'}
                          validate={
                            locale === 'en'
                              ? getValidator(VALIDATOR_IS_EMPTY)
                              : null
                          }
                        />
                      )}
                      {unit && (
                        <Field
                          name={`${locale}[unit]`}
                          type="text"
                          label={`${locale} ${formatMessage(messages.unit)}`}
                          component={Input}
                          className="form-control"
                          defaultValue={unit}
                          disabled={submitting}
                          required={locale === 'en'}
                          validate={
                            locale === 'en'
                              ? getValidator(VALIDATOR_IS_EMPTY)
                              : null
                          }
                        />
                      )}
                    </Grid>
                  ),
                )}
                <div className="form-group buttons">
                  <Button
                    href={null}
                    type="submit"
                    color="primary"
                    size="medium"
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={submitting || pristine}>
                    {formatMessage(messages.saveInfo)}
                  </Button>
                </div>
              </form>
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default connect(
  state => ({
    loading: state.getIn(['jobWorkflowInputTranslations', 'loading']),
  }),
  {},
)(injectIntl(JobWorkflowInputForm))
